import { render, staticRenderFns } from "./sessionDashboard.vue?vue&type=template&id=52ec73be&scoped=true"
import script from "./sessionDashboard.vue?vue&type=script&lang=js"
export * from "./sessionDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec73be",
  null
  
)

export default component.exports